import React from 'react';
import {TestimonialMessage} from './testimonialmessage';
import testimonial from '../../Assets/testimonial.jpg';
import testimonial1 from '../../Assets/testimonial1.jpg';
import testimonial2 from '../../Assets/testimonial2.jpg';
import testimonial3 from '../../Assets/testimonial3.jpg';
export function Testimonial(props) {

    return (
        <React.Fragment>
            <div id="carouselExampleInterval" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active" data-interval="100000">
        <TestimonialMessage testimonial = {testimonial}/>    
        <TestimonialMessage testimonial = {testimonial1}/>      
        <TestimonialMessage testimonial = {testimonial2}/> 
    </div>  
    <div class="carousel-item " data-interval="100000">
        <TestimonialMessage testimonial = {testimonial3}/>    
        <TestimonialMessage testimonial = {testimonial1}/>      
        <TestimonialMessage testimonial = {testimonial2}/> 
    </div>     
  </div>
  <a class="carousel-control-prev" href="#carouselExampleInterval" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleInterval" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
        </React.Fragment>
    )
}